<div class="container">
    <div class="section-heading text-center">
        <h2>Praise from Clients</h2>
    </div>
    <div class="row g-3">
        <div class="col-sm-6 col-lg-4">
            <div class="testimonials-box">
                <div class="t-icon">
                    <img src="assets/img/brand-1.svg" title="" alt="">
                </div>
                <h5>Our expectations were surpassed by the exceptional web design</h5>
                <p>Detail and creativity exceeded our expectations during our website redesign. The visually stunning and user-friendly site she produced immediately enhanced our online presence</p>
                <div class="t-user">
                    <div class="t-user-icon">
                        <img src="assets/img/avatar-1.jpg" title="" alt="">
                    </div>
                    <div class="t-text">
                        <h6>Will Smith</h6>
                        <span>Sample Company</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-sm-6 col-lg-4">
            <div class="testimonials-box">
                <div class="t-icon">
                    <img src="assets/img/brand-2.svg" title="" alt="">
                </div>
                <h5>Our expectations were surpassed by the exceptional web design</h5>
                <p>Detail and creativity exceeded our expectations during our website redesign. The visually stunning and user-friendly site she produced immediately enhanced our online presence</p>
                <div class="t-user">
                    <div class="t-user-icon">
                        <img src="assets/img/avatar-2.jpg" title="" alt="">
                    </div>
                    <div class="t-text">
                        <h6>Will Smith</h6>
                        <span>Sample Company</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-sm-6 col-lg-4">
            <div class="testimonials-box">
                <div class="t-icon">
                    <img src="assets/img/brand-1.svg" title="" alt="">
                </div>
                <h5>Our expectations were surpassed by the exceptional web design</h5>
                <p>Detail and creativity exceeded our expectations during our website redesign. The visually stunning and user-friendly site she produced immediately enhanced our online presence</p>
                <div class="t-user">
                    <div class="t-user-icon">
                        <img src="assets/img/avatar-3.jpg" title="" alt="">
                    </div>
                    <div class="t-text">
                        <h6>Will Smith</h6>
                        <span>Sample Company</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-sm-6 col-lg-4">
            <div class="testimonials-box">
                <div class="t-icon">
                    <img src="assets/img/brand-2.svg" title="" alt="">
                </div>
                <h5>Our expectations were surpassed by the exceptional web design</h5>
                <p>Detail and creativity exceeded our expectations during our website redesign. The visually stunning and user-friendly site she produced immediately enhanced our online presence</p>
                <div class="t-user">
                    <div class="t-user-icon">
                        <img src="assets/img/avatar-4.jpg" title="" alt="">
                    </div>
                    <div class="t-text">
                        <h6>Will Smith</h6>
                        <span>Sample Company</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-sm-6 col-lg-4">
            <div class="testimonials-box">
                <div class="t-icon">
                    <img src="assets/img/brand-1.svg" title="" alt="">
                </div>
                <h5>Our expectations were surpassed by the exceptional web design</h5>
                <p>Detail and creativity exceeded our expectations during our website redesign. The visually stunning and user-friendly site she produced immediately enhanced our online presence</p>
                <div class="t-user">
                    <div class="t-user-icon">
                        <img src="assets/img/avatar-1.jpg" title="" alt="">
                    </div>
                    <div class="t-text">
                        <h6>Will Smith</h6>
                        <span>Sample Company</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-sm-6 col-lg-4">
            <div class="testimonials-box">
                <div class="t-icon">
                    <img src="assets/img/brand-2.svg" title="" alt="">
                </div>
                <h5>Our expectations were surpassed by the exceptional web design</h5>
                <p>Detail and creativity exceeded our expectations during our website redesign. The visually stunning and user-friendly site she produced immediately enhanced our online presence</p>
                <div class="t-user">
                    <div class="t-user-icon">
                        <img src="assets/img/avatar-3.jpg" title="" alt="">
                    </div>
                    <div class="t-text">
                        <h6>Will Smith</h6>
                        <span>Sample Company</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>